var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.78613 7.52441H10.3838V9.04199H7.78613V12.002H6.17285V9.04199H3.56152V7.52441H6.17285V4.75586H7.78613V7.52441Z"}));
}

IconPlus.defaultProps = {"viewBox":"0 0 14 16","fill":"none"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
